import React from "react";
import TagButton from "../common/TagButton";


const PolygonWebVector = "https://storage.googleapis.com/think41-web-new/assets/Career/00%20polygon%20web%20vector%20updated.svg"
const TeamImage = "https://storage.googleapis.com/think41-web-new/assets/Career/team-photo.png"

const OurStory = () => (
  <div className="h-full w-full overflow-hidden relative">
    {/* Background PolygonWebVector with opacity */}
    <div
      aria-hidden="true"
      style={{
        backgroundImage: `url(${PolygonWebVector})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "80vw auto",
        backgroundPosition: "left top",
        opacity: 0.5,
        position: "absolute",
        inset: 0,
        zIndex: 0,
        pointerEvents: "none",
      }}
    />

    {/* === DESKTOP VIEW === */}
    <section
      className="hidden md:flex w-[1200px] mx-auto flex-col gap-[36px] relative"
      id="our-story"
      style={{ minHeight: "520px" }}
    >
      <div style={{ height: 36 }} />
      <div className="flex flex-col gap-[36px] relative z-[1]">
        <TagButton text="Foundation" />
        <div className="flex gap-[32px] w-full relative z-[2]">
          <div className="flex-1 text-[#444] font-roboto text-[16px] leading-[28px]">
            <h2 className="text-[40px] font-bold font-montserrat mb-2 relative z-[2]">
              <span className="bg-gradient-to-r from-[#000] to-[#0060C7] bg-clip-text text-transparent">
                Our Story
              </span>
            </h2>
            <div style={{ height: 24 }} />
            <div className="text-[#444] font-roboto text-[16px] font-light leading-[28px] mb-6 text-justify">
              We’re not just building with AI. We’re building a company where AI
              and people grow together. At Think41, AI is more than our focus;
              it’s our mindset. We co-build GenAI systems with enterprises and
              foster a fast, people-first culture where AI handles the
              repetitive so you can focus on solving real problems and shipping
              meaningful work.
            </div>
            <div className="mb-6 font-light text-justify">
              Our strength lies in our people, from Boot41 grads to top
              engineers and experienced founders. We blend talent, innovation
              and ownership to create a place where learning is personal, impact
              is shared and engineering excellence thrives.
            </div>
          </div>
          <div className="flex-1 flex items-center justify-center">
            <img
              src={TeamImage}
              alt="Team"
              className="w-full max-w-[600px] h-auto rounded-[16px] object-cover shadow-[0_2px_24px_rgba(0,0,0,0.07)]"
            />
          </div>
        </div>
      </div>
    </section>

    {/* === MOBILE VIEW === */}
    <section
      className="md:hidden w-full flex flex-col relative z-[2]"
      id="our-story"
    >
      <div style={{ height: 36 }} />
      <div className="px-5 flex flex-col gap-[36px]">
        <TagButton text="Foundation" />
        <h2 className="text-[24px] font-bold font-montserrat mb-2 relative z-[2] inline-block w-fit">
          <span className="bg-gradient-to-r from-[#000] to-[#0060C7] bg-clip-text text-transparent">
            Our Story
          </span>
        </h2>
        <img
          src={TeamImage}
          alt="Team"
          className="w-full rounded-[12px] object-cover shadow-[0_2px_24px_rgba(0,0,0,0.07)]"
        />
        <div className="text-[#444] text-[14px] font-roboto leading-[22px] flex flex-col gap-4 mb-6 font-light">
          <p>
            We’re not just building with AI. We’re building a company where AI
            and people grow together. At Think41, AI is more than our focus;
            it’s our mindset. We co-build GenAI systems with enterprises and
            foster a fast, people-first culture where AI handles the repetitive
            so you can focus on solving real problems and shipping meaningful
            work.
          </p>
          <p>
            Our strength lies in our people, from Boot41 grads to top engineers
            and experienced founders. We blend talent, innovation and ownership
            to create a place where learning is personal, impact is shared and
            engineering excellence thrives.
          </p>
        </div>
      </div>
    </section>
  </div>
);

export default OurStory;
